import { useEffect, useState } from 'react';
import { IconEdit, PermissionEnum } from '@ui/src';
import { GeneralCompanyInfoTypes } from './types';
import OverviewGeneralRow from './parts/general-row';
import GeneralInfoCompanyTop from './parts/general-info-top';
import Card from '../../common/card/card';
import { CustomerStatus } from '../../../hoc/common/types';

import cn from './styles.module.css';

const GeneralCompanyInfo = ({
  isSuccess,
  incorporationDates,
  sicCodesDictionaries,
  productsCorporate,
  countries,
  activePermissions,
  general,
  control,
  errors,
  correspondenceAddressSameAsRegisteredAddress,
  businessAddressSameAsRegisteredAddress,
  isLoading,
  globalError,
  onSubmit,
  requestInProgress,
  status,
}: GeneralCompanyInfoTypes) => {
  const [edit, setEdit] = useState(false);

  useEffect(() => {
    if (isSuccess) {
      setEdit(false);
    }
  }, [isSuccess]);

  return (
    <Card title="General Info" isLoading={isLoading}>
      <GeneralInfoCompanyTop
        edit={edit}
        control={control}
        errors={errors}
        general={general}
        incorporationDates={incorporationDates}
        countries={countries}
        sicCodesDictionaries={sicCodesDictionaries}
        productsCorporate={productsCorporate}
        correspondenceAddressSameAsRegisteredAddress={
          correspondenceAddressSameAsRegisteredAddress
        }
        businessAddressSameAsRegisteredAddress={
          businessAddressSameAsRegisteredAddress
        }
      />
      <div className={cn.generalBottom}>
        <OverviewGeneralRow
          title="Business description"
          description={general?.businessDescription}
          edit={edit}
          control={control}
          type="textarea"
          name="businessDescription"
          error={errors?.businessDescription?.message}
        />
      </div>
      <div className={cn.editControls}>
        {globalError && <div className={cn.globalError}>{globalError}</div>}
        {edit && (
          <>
            <button
              type="submit"
              className={cn.saveButton}
              aria-label="Edit Button"
              onClick={onSubmit}
              disabled={requestInProgress}
            >
              {requestInProgress ? 'Loading...' : 'Save'}
            </button>
            <button
              type="button"
              className={cn.cancelButton}
              aria-label="Cance Button"
              onClick={() => setEdit(false)}
            >
              Cancel
            </button>
          </>
        )}
        {!edit &&
          status !== CustomerStatus.CLOSED &&
          activePermissions?.includes(
            PermissionEnum.CORPORATE_CUSTOMERS_EDIT_DETAILS_ACTION,
          ) && (
            <button
              type="button"
              className={cn.editButton}
              aria-label="Edit Button"
              onClick={() => setEdit(true)}
            >
              <IconEdit /> Edit
            </button>
          )}
      </div>
    </Card>
  );
};

export default GeneralCompanyInfo;
